<template>
  <div>
    <el-tabs v-if="showVcenterLogTab" class="tab-button" v-model="activeTabVcenter">
      <el-tab-pane label="vCenter 로그" name="vcenterlog">
        <w-vcenter-log-view @time-type-change="setTimeType('vcenterlog', $event)" :active="active && activeTabName === 'vcenterlog'" :timeType="logInfoType" :activeTab="activeTabName" :operation-flag="operationFlag" />
      </el-tab-pane>
    </el-tabs>
    <el-tabs v-if="showHypervLogTab" class="tab-button" v-model="activeTabHyperv">
      <el-tab-pane label="HYPER-V 로그" name="hypervlog">
        <w-hyperv-log-view @time-type-change="setTimeType('hypervlog', $event)" :active="active && activeTabName === 'hypervlog'" :timeType="logInfoType" :activeTab="activeTabName" :operation-flag="operationFlag" />
      </el-tab-pane>
    </el-tabs>
    <el-tabs v-if="showRhevLogTab" class="tab-button" v-model="activeTabRhev">
      <el-tab-pane label="RHEV 로그" name="rhevlog">
        <w-rhev-log-view @time-type-change="setTimeType('rhevlog', $event)" :active="active && activeTabName === 'rhevlog'" :timeType="logInfoType" :activeTab="activeTabName" :operation-flag="operationFlag" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import isNil from 'lodash/isNil';
import isEmpty from 'lodash/isEmpty';
import { mapGetters } from 'vuex';
import { objType } from '@/constants/obj';
import AnalysisTable from '@/mixins/performance/analysis-table';
import { analysisTimeType, defaultAnalysisTimeType } from '@/constants/performance';
import WVcenterLogView from './components/VcenterLogView';
import WHypervLogView from './components/HypervLogView';
import WRhevLogView from './components/RhevLogView';

export default {
  name: 'WPerformanceVirtualAnalysisTable',
  components: {
    WVcenterLogView,
    WHypervLogView,
    WRhevLogView,
  },
  mixins: [AnalysisTable],
  props: {
    active: Boolean,
    operationFlag: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      logInfoType: 'hist',
      activeTabVcenter: 'vcenterlog',
      activeTabHyperv: 'hypervlog',
      activeTabRhev: 'rhevlog',
      analysisTimeType,
      timeType: {
        vcenterlog: defaultAnalysisTimeType,
      },
    };
  },
  computed: {
    activeTabName() {
      let result = '';
      if (this.selectedNode.hypervisorType === 'VMWARE') {
        result = 'vcenterlog';
      } else if (this.selectedNode.hypervisorType === 'HYPERV') {
        result = 'hypervlog';
      } else if (this.selectedNode.hypervisorType === 'RHEV') {
        result = 'rhevlog';
      }
      return result;
    },
    showVcenterLogTab() {
      return this.selectedNode.hypervisorType === 'VMWARE';
    },
    showHypervLogTab() {
      return this.selectedNode.hypervisorType === 'HYPERV';
    },
    showRhevLogTab() {
      return this.selectedNode.hypervisorType === 'RHEV';
    },
    ...mapGetters(['selectedNode', 'plotLineDatetime']),
  },
  watch: {
    /**
     * [plotLineDatetime 차트 클릭시 테이블 데이터 로드]
     * 케이스 3 의 파라미터 = 클릭된 체크박스 값
     * @author {Yang}
     * @return {[type]} [description]
     */
    plotLineDatetime() {
      this.selectedTabTableLoad();
    },
    /**
     * [activeTab 탭 선택시 로드]
     * @author {Yang}
     * @return {[String]}  [ 0- 프로세스 정보, 1- 세션 정보, 2-로그정보, 3-시스템 접근정보]
     */
    activeTabName() {
      this.selectedTabTableLoad();
    },
    /**
     * [분석] 탭이 활성화 시 현재 보여지는 탭의 데이터를 재로드한다.
     * @param  {[type]} active [description]
     * @return {[type]}        [description]
     * @author jda
     */
    active(active) {
      if (active) {
        this.selectedTabTableLoad();
      }
    },
    selectedNode: {
      handler(node) {
        if (!this.active || isEmpty(node)) {
          return;
        }
        this.isChangeNodeFlag = true;
        // [운영] 노드 변경 시 처리
        if (this.operationFlag) {
          this.selectedTabTableLoad();
        }
      },
      immediate: true,
    },
  },
  methods: {
    selectedTabTableLoad() {
      if ((isNil(this.plotLineDatetime) && !this.operationFlag) || !this.active || isEmpty(this.selectedNode)) {
        return;
      }
      if (this.isChangeNodeFlag) {
        this.clearTimeType();
        this.$nextTick(() => {
          this.loadStore();
          this.isChangeNodeFlag = false;
        });
      } else if (this.operationFlag) {
        // [운영] VMS - vLog 조회 시 현재 데이터로 조회하도록한다.
        this.$set(this.timeType, 'vcenterlog', 'current');
        this.$nextTick(() => {
          this.loadStore();
        });
      } else {
        this.loadStore();
      }
    },
    loadStore() {
      if ((isNil(this.plotLineDatetime) && !this.operationFlag) || !this.active || this.selectedNode.subType !== objType.VIRTUAL) {
        return;
      }
      // switch (this.activeTabName) {
      //   case 'vcenterlog':
      //     this.vcenterlogLoadStore();
      //     break;
      //   case 'hypervlog':
      //     this.vcenterlogLoadStore();
      //     break;
      //   case 'rhevlog':
      //     this.vcenterlogLoadStore();
      //     break;
      //   default:
      //     this.vcenterlogLoadStore();
      // }
      this.logInfoType = null;
      this.$nextTick(() => {
        this.logInfoType = cloneDeep(this.timeType.vcenterlog);
      });
    },
    // vcenterlogLoadStore() {
    //   this.logInfoType = cloneDeep(this.timeType.vcenterlog);
    // },
    setTimeType(type, value) {
      this.timeType[type] = value;
      this.selectedTabTableLoad();
    },
    clearTimeType() {
      const hist = defaultAnalysisTimeType;
      if (this.operationFlag) {
        this.$set(this.timeType, 'vcenterlog', 'current');
      } else {
        this.$set(this.timeType, 'vcenterlog', hist);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/performance/node/analysis/virtual/PerformanceVirtualAnalysisTable.vue